import { AUTH_MESSAGES } from "../../../../api/newAuthorization";
import type { AuthorizationState, RequestContext } from "./types";
import type { LoginFormState } from "../../../../store/loginFormStore";
import { useAuthorizationStore } from "../../../../store/authorizationStore";
import { EPassportFormState } from "../../../../store/slices/passportFormSliceCreator";

interface PassportContext extends RequestContext {
  auth: Pick<AuthorizationState, "authSessionId" | "foreignPassport">;
  login: Pick<LoginFormState, "getEscapedPassportNumber" | "passportType" | "setFormState">;
}

export async function verifyPassport({ auth, login, request, isCurrent, navigate }: PassportContext) {
  if (!auth.authSessionId) {
    throw new Error(AUTH_MESSAGES.passport);
  }

  await request(`/sessions/${encodeURIComponent(auth.authSessionId)}/check`, {
    passport: login.getEscapedPassportNumber(),
    type: auth.foreignPassport && login.passportType === "PASSPORT_FOREIGN" ? "FOREIGN" : "RUS",
  });

  if (!isCurrent()) {
    return;
  }

  useAuthorizationStore.setState({ passportChecked: true });
  login.setFormState(EPassportFormState.submitted);
  navigate("/login/pin", { replace: true });
}
